<template>
	<div class="resume-page cv">
		<div class="cv__wrapper">
			<section class="cv__header">
				<h1 class="cv__name">
					{{ personalInfo.name }}
				</h1>
				<h4 class="cv__title">
					{{ personalInfo.title }}
				</h4>
				<div class="cv__contact-info">
					<div class="cv__phone">
						<PhoneIcon />
						<span
							>{{ personalInfo.phone.slice(0, 6) }}XXXXXXXX</span
						>
					</div>
					<div class="cv__phone-on-hover">
						<PhoneIcon />
						<span>{{ personalInfo.phone }}</span>
					</div>
					<div class="cv__web">
						<LinkIcon />
						<a :href="personalInfo.web">{{ personalInfo.web }}</a>
					</div>
					<div class="cv__email">
						<MailIcon />
						<a href="mailto:selimialtin@gmail.com">{{
							personalInfo.email
						}}</a>
					</div>
					<div class="cv__location">
						<MapPinIcon />
						<span>{{ personalInfo.location }}</span>
					</div>
				</div>
			</section>
			<article class="cv__content">
				<section>
					<h2>Experience</h2>
					<ExperienceCard
						v-for="experience in experiences"
						:role="experience.role"
						:companyName="experience.companyName"
						:companyUrl="experience.companyUrl"
						:year="experience.year"
						:location="experience.location"
						:description="experience.companyDescription"
						:achievements="experience.achievements"
					/>
				</section>
				<section>
					<h2>Fun Projects</h2>
					<div class="cv__fun-projects">
						<FunProjectCard
							v-for="project in funProjects"
							:name="project.name"
							:description="project.description"
							:url="project.url"
						/>
					</div>
				</section>
				<section>
					<h2>Skills</h2>
					<div
						class="cv__skills"
						v-for="(skillCategory, skillName) in skillCategories"
					>
						<p class="cv__skills-name">{{ skillName }}</p>
						<ul class="cv__skills-list">
							<li v-for="skill in skillCategory">
								{{ skill }}
							</li>
						</ul>
					</div>
				</section>
			</article>
		</div>
		<div class="cv__download-pdf">
			<DownloadIcon />
			<a href="./resume.pdf">Download PDF</a>
		</div>
	</div>
</template>
<script>
import {
	personalInfo,
	experiences,
	frontendSkills,
	backendSkills,
	mobileSkills,
	funProjects,
} from "@/data/cv.js";

import {
	MailIcon,
	PhoneIcon,
	LinkIcon,
	MapPinIcon,
	DownloadIcon,
} from "vue-feather-icons";

import ExperienceCard from "@/components/ExperienceCard.vue";

import FunProjectCard from "@/components/FunProjectCard.vue";

export default {
	components: {
		ExperienceCard,
		FunProjectCard,
		MailIcon,
		PhoneIcon,
		LinkIcon,
		MapPinIcon,
		DownloadIcon,
	},
	data() {
		return {
			personalInfo,
			experiences,
			frontendSkills,
			backendSkills,
			mobileSkills,
			funProjects,
		};
	},
	computed: {
		skillCategories() {
			return {
				frontend: frontendSkills,
				backend: backendSkills,
				mobile: mobileSkills,
			};
		},
	},
};
</script>
<style lang="scss">
@import url("https://rsms.me/inter/inter.css");
@import url("https://fonts.googleapis.com/css?family=Rubik:400,500,700&display=swap");

.resume-page {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding-top: 20px;
	padding-bottom: 40px;
	iframe {
		border: none;
		height: 790px;
		width: 100%;
	}
	h1,
	h2,
	h3,
	h4,
	h5 {
		margin: 0;
		font-family: "Rubik", Arial, Helvetica, "Noto Sans Devanagari",
			"Noto Sans CJK SC Thin", "Noto Sans SC", "Noto Sans Hebrew",
			sans-serif !important;
	}
	p,
	li,
	span {
		font-family: "Inter", Arial, Helvetica, "Noto Sans Devanagari",
			"Noto Sans CJK SC Thin", "Noto Sans SC", "Noto Sans Hebrew",
			sans-serif !important;
		@supports (font-variation-settings: normal) {
			font-family: "Inter var", sans-serif;
		}
		color: var(--resume-shade);
	}
}

.cv {
	&__wrapper {
		border: dashed 1px #ccc;
		border-radius: 4px;
		padding: 15px;
	}
	&__header {
		display: flex;
		flex-direction: column;
	}

	&__contact-info:hover {
		> .cv__phone-on-hover {
			display: flex;
		}
		> .cv__phone {
			display: none;
		}
	}
	&__contact-info > &__phone-on-hover {
		display: none;
	}
	&__name {
		font-size: 32px;
		line-height: 50px;
		font-weight: 700 !important;
		color: black;
		text-transform: uppercase;
	}
	&__title {
		color: var(--secondary-theme);
		font-size: 21px;
		line-height: 25px;
		font-weight: 700 !important;
	}
	&__contact-info {
		font-size: 12px;
		font-weight: 700;
		line-height: 16px;
		margin-left: 1px;
		margin-top: 20px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		> div {
			display: flex;
			align-items: center;
			margin-bottom: 3px;
			margin-right: 5px;
		}
		svg {
			width: 12px;
			height: 12px;
			stroke: var(--secondary-theme);
			margin-right: 8px;
		}
	}
	&__content > section {
		margin-top: 30px;
	}
	&__content h2 {
		display: block;
		margin: 0;
		border-bottom: 3px solid #000;
		text-transform: uppercase;
		font-size: 22px;
		line-height: 33px;
		font-weight: 700;
	}
	a {
		color: var(--resume-shade);
		text-decoration: none;
	}

	&__fun-projects {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 40px;
	}

	&__skills {
		display: flex;
		flex-direction: column;
		padding: 15px 0px;
	}
	&__skills-name {
		font-size: 21px;
		line-height: 25px;
		font-weight: 500;
		text-transform: capitalize;
	}
	&__skills-list {
		display: flex;
		padding: 0px;
		margin: 0px;
		list-style: none;
		flex-wrap: wrap;
		> li {
			margin-right: 15px;
			border-bottom: solid 1px black;
			font-weight: 600;
			padding: 5px 8px;
			margin-top: 5px;
			font-size: 14px;
		}
	}
	&__download-pdf {
		align-self: flex-end;
		margin: 10px 0px;
		padding: 10px;
		display: flex;
		align-items: center;
		border-bottom: dashed 1px black;
		font-size: 16px;
		&:hover {
			border-bottom-color: var(--secondary-theme);
			color: var(--secondary-theme);
			a {
				color: var(--secondary-theme);
			}
		}
		svg {
			width: 14px;
			height: 14px;
			margin-right: 10px;
		}
	}
}
</style>
